import { getCookie } from "../utils";

export const API_HOST =
  window.location.host === "www.dldausnagar.in" ||
  window.location.host === "dldausnagar.in"
    ? `${window.location.origin}/api`
    : "https://www.dldausnagar.in/api";

export const apiService = async (
  endpoint: string,
  method: string,
  body?: any
) => {
  const payload: any = {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getCookie("token")}`,
    },
  };
  if (body) {
    payload.body = JSON.stringify(body);
  }
  const response = await fetch(`${API_HOST}${endpoint}`, payload);
  return response.json();
};
